<template>
  <v-card
    class="door"
    color="background"
    rounded="lg"
    variant="flat"
    :ripple="false"
    @click="$emit('activate', door.id)"
  >
    <div class="door-tag">
      <v-icon :icon="door.tagIcon" size="14" /> {{ door.tag }}
    </div>
    <h3 class="door-headline">{{ door.headline }}</h3>
    <p class="door-desc text-medium-emphasis">{{ door.desc }}</p>
    <div class="door-action">
      <span>{{ door.action }}</span>
      <v-icon icon="mdi-arrow-right" size="18" class="door-arrow" />
      <span v-if="door.fineprint" class="door-fineprint text-disabled">{{ door.fineprint }}</span>
    </div>
  </v-card>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component'
import { Door } from './landingContent'

@Options({
  props: {
    door: { type: Object, required: true }
  },
  emits: ['activate']
})
export default class DoorCard extends Vue {
  door!: Door
}
</script>

<style scoped lang="scss">
.door {
  height: 100%;
  min-height: 320px;
  padding: 36px 32px;
  display: flex;
  flex-direction: column;
  border: 1px solid var(--l-border);
  transition: border-color 0.2s, box-shadow 0.2s, transform 0.2s;
}
.door:hover {
  border-color: rgb(var(--v-theme-primary));
  box-shadow: 0 0 0 1px rgba(var(--v-theme-primary), 0.4), 0 0 24px rgba(var(--v-theme-primary), 0.18);
  transform: translateY(-2px);
}
.v-theme--light .door:hover {
  border-color: rgb(var(--v-theme-on-background));
  box-shadow: 0 4px 0 rgb(var(--v-theme-on-background));
}
.door-tag {
  font-family: var(--l-mono);
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.2em;
  text-transform: uppercase;
  color: rgb(var(--v-theme-accent-ink));
  margin-bottom: 20px;
  display: flex;
  align-items: center;
  gap: 8px;
}
.door-headline {
  font-size: 26px;
  line-height: 1.1;
  font-weight: 700;
  letter-spacing: -0.015em;
  margin: 0 0 14px;
}
.door-desc {
  font-size: 15px;
  line-height: 1.55;
  margin: 0 0 24px;
  flex-grow: 1;
}
.door-action {
  display: flex;
  align-items: center;
  gap: 12px;
  border-top: 1px solid var(--l-border);
  padding-top: 20px;
  font-size: 13px;
  font-weight: 500;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: rgb(var(--v-theme-primary));
}
.v-theme--light .door-action {
  color: rgb(var(--v-theme-on-background));
}
.door-arrow {
  transition: transform 0.2s;
}
.door:hover .door-arrow {
  transform: translateX(6px);
}
.door-fineprint {
  margin-left: auto;
  font-family: var(--l-mono);
  font-size: 10px;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  text-align: right;
}
@media (max-width: 560px) {
  /* fineprint drops below the action so the label stays on one line */
  .door-action {
    flex-wrap: wrap;
  }
  .door-fineprint {
    width: 100%;
    margin-left: 0;
    text-align: left;
  }
}
</style>
